export default "__VITE_ASSET__x96iMraJ__"